import { useState } from 'react'

import { EMPTY_LIST } from '../../../constants/common'
import { AsyncTasks } from '../../../context'

function AsyncTaskProvider({ children }) {
  const [asyncTasks, setAsyncTasks] = useState(EMPTY_LIST)

  function addAsyncTask(task) {
    setAsyncTasks(prevValue => [...prevValue, task])
  }

  function removeAsyncTask(id) {
    setAsyncTasks(prevValue => {
      clearInterval(prevValue.find(task => task.id === id)?.interval)

      return prevValue.filter(item => item.id !== id)
    })
  }

  return (
    <AsyncTasks
      value={{
        addAsyncTask,
        asyncTasks,
        removeAsyncTask,
      }}
    >
      {children}
    </AsyncTasks>
  )
}

export default AsyncTaskProvider
